import { Component, Input } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import {
  FundId,
  FundPerformanceCalendarYearStateConfig,
  FundPerformanceCalendarYearTableData,
  FundPerformanceDates,
} from '@types';

@Component({
  selector: 'ft-fund-performance-calendar-year-table',
  templateUrl: './fund-performance-calendar-year-table.component.html',
  styleUrls: ['./fund-performance-calendar-year-table.component.scss'],
})
export class FundPerformanceCalendarYearTableComponent extends BaseTableResponsiveComponent {
  @Input() fundPerformanceData: FundPerformanceCalendarYearTableData[];
  @Input() fundPerformanceConfig: FundPerformanceCalendarYearStateConfig;
  @Input() fundPerformanceDates: FundPerformanceDates;
  @Input() tableLabel: string;
  @Input() years: string[];
  @Input() tableCols: string[];
  @Input() showYearToDate: boolean;
  @Input() fundId: FundId;
  @Input() isAllShareClasses: boolean;
  @Input() containerId?: string;

  constructor(protected responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
